import * as React from 'react';

const NoOrders: React.FC<React.SVGProps<SVGSVGElement>> = () => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='160'
		height='160'
		viewBox='0 0 160 160'
		fill='none'>
		<foreignObject x='2.35291' y='47.8516' width='154.002' height='113.297'>
			<div
				style={{
					backdropFilter: 'blur(15px)',
					clipPath: 'url(#bgblur_0_3021_91485_clip_path)',
					height: '100%',
					width: '100%',
				}}
			/>
		</foreignObject>

		<path
			data-figma-bg-blur-radius='30'
			d='M34.6849 107.969C31.5927 106.244 31.5731 103.413 34.6412 101.645L73.6016 79.2001C76.6697 77.4326 81.6637 77.3982 84.7559 79.1234L124.023 101.03C127.115 102.756 127.135 105.587 124.066 107.355L85.1061 129.8C82.038 131.567 77.044 131.602 73.9518 129.876L34.6849 107.969Z'
			fill='black'
		/>

		<foreignObject x='-0.773804' y='22.6475' width='160.548' height='117.008'>
			<div
				style={{
					backdropFilter: 'blur(15px)',
					clipPath: 'url(#bgblur_1_3021_91485_clip_path)',
					height: '100%',
					width: '100%',
				}}
			/>
		</foreignObject>

		<path
			data-figma-bg-blur-radius='30'
			d='M31.5582 84.6432C28.466 82.9181 28.4464 80.0867 31.5145 78.3191L73.7349 53.9959C76.803 52.2283 81.797 52.194 84.8892 53.9191L127.442 77.6592C130.534 79.3844 130.554 82.2158 127.485 83.9833L85.265 108.307C82.1969 110.074 77.2029 110.108 74.1107 108.383L31.5582 84.6432Z'
			fill='#D3D3D3'
			fillOpacity={0.3}
		/>

		<foreignObject x='-0.773804' y='-1.14844' width='160.548' height='117.008'>
			<div
				style={{
					backdropFilter: 'blur(15px)',
					clipPath: 'url(#bgblur_2_3021_91485_clip_path)',
					height: '100%',
					width: '100%',
				}}
			/>
		</foreignObject>

		<path
			data-figma-bg-blur-radius='30'
			d='M31.5582 60.8473C28.466 59.1222 28.4464 56.2908 31.5145 54.5232L73.7349 30.2C76.803 28.4324 81.797 28.3981 84.8892 30.1232L127.442 53.8633C130.534 55.5885 130.554 58.4199 127.485 60.1874L85.265 84.5107C82.1969 86.2782 77.2029 86.3126 74.1107 84.5874L31.5582 60.8473Z'
			fill='#D3D3D3'
			fillOpacity={0.3}
		/>

		<path
			d='M71.8055 56.9202C71.8013 56.3114 72.6684 55.8118 73.7424 55.8044L85.4097 55.7241C86.4836 55.7167 87.3576 56.2043 87.3618 56.8132C87.366 57.4221 86.4988 57.9217 85.4249 57.9291L73.7576 58.0094C72.6837 58.0167 71.8097 57.5291 71.8055 56.9202Z'
			fill='white'
		/>

		<path
			d='M79.5532 52.4568C80.6271 52.4494 81.5011 52.937 81.5053 53.5459L81.551 60.1608C81.5552 60.7697 80.6881 61.2693 79.6141 61.2767C78.5402 61.2841 77.6662 60.7965 77.6619 60.1876L77.6162 53.5726C77.612 52.9637 78.4792 52.4642 79.5532 52.4568Z'
			fill='white'
		/>

		<defs>
			<clipPath id='bgblur_0_3021_91485_clip_path' transform='translate(-2.35291 -47.8516)'>
				<path d='M34.6849 107.969C31.5927 106.244 31.5731 103.413 34.6412 101.645L73.6016 79.2001C76.6697 77.4326 81.6637 77.3982 84.7559 79.1234L124.023 101.03C127.115 102.756 127.135 105.587 124.066 107.355L85.1061 129.8C82.038 131.567 77.044 131.602 73.9518 129.876L34.6849 107.969Z' />
			</clipPath>

			<clipPath id='bgblur_1_3021_91485_clip_path' transform='translate(0.773804 -22.6475)'>
				<path d='M31.5582 84.6432C28.466 82.9181 28.4464 80.0867 31.5145 78.3191L73.7349 53.9959C76.803 52.2283 81.797 52.194 84.8892 53.9191L127.442 77.6592C130.534 79.3844 130.554 82.2158 127.485 83.9833L85.265 108.307C82.1969 110.074 77.2029 110.108 74.1107 108.383L31.5582 84.6432Z' />
			</clipPath>

			<clipPath id='bgblur_2_3021_91485_clip_path' transform='translate(0.773804 1.14844)'>
				<path d='M31.5582 60.8473C28.466 59.1222 28.4464 56.2908 31.5145 54.5232L73.7349 30.2C76.803 28.4324 81.797 28.3981 84.8892 30.1232L127.442 53.8633C130.534 55.5885 130.554 58.4199 127.485 60.1874L85.265 84.5107C82.1969 86.2782 77.2029 86.3126 74.1107 84.5874L31.5582 60.8473Z' />
			</clipPath>
		</defs>
	</svg>
);

export default NoOrders;
